
var recipeList = [],
    displayRecipeData = [],
    filtersArray = [],
    newRecipeData = [],
    total = 0,
    page = 1,
    totalPage = 1,
    modalType = '',
    servingSize = 0


window.onload = function () {
    initRecipeTagsHtml()
    getRecipeData()
    topFunction()
    // var fixedDom = document.getElementsByClassName('to-top-icon')[0]
    //  console.log(fixedDom)


    /** load more */
    $('.load_btn').on('click', function () {
        changePage(page + 1)
    })

    /** Mobile Filters --- Open */
    $('.filters').on('click', function () {
        modalType = 'tag'
        $('.modal-footer').text('See Results')
        $('.modal-header-title').text('Filters')
        $('.xs-tags').css({ 'display': 'block' })
        $('.ingredients-box').css({ 'display': 'none' })
        $('.serving-box').css({ 'display': 'none' })
        openModal()
    })

    $('.ingrendents').on('click', function () {
        modalType = 'ingrendents'
        $('.modal-footer').text('Apply Filters')
        $('.modal-header-title').text('Ingredients')
        $('.xs-tags').css({ 'display': 'none' })
        $('.ingredients-box').css({ 'display': 'flex' })
        $('.serving-box').css({ 'display': 'none' })
        openModal()
    })

    $('.serving').on('click', function () {
        modalType = 'serving'
        $('.modal-footer').text('Apply Filters')
        $('.modal-header-title').text('Serving Size')
        $('.xs-tags').css({ 'display': 'none' })
        $('.ingredients-box').css({ 'display': 'none' })
        $('.serving-box').css({ 'display': 'flex' })
        openModal()
    })

    $('.modal-footer').on('click', function () {
        closeModal()
        if (modalType == 'tag') {
            var filtersNum = filtersArray.length
            $('.filters .num').text('(' + filtersNum + ')')
            getInputCheckbox({ filter: true })
        } else if (modalType == 'ingrendents') {
            getRecipeData()
        } else if (modalType == 'serving') {
            getRecipeData()
            $('.serving .num').text('(' + servingSize + ')')

        }
    })

    /** Mobile Filters ---fullMask -- Close */
    $('.full-mask').on('click', function () {
        closeModal()
    })

    /** Mobile Filters -- Modal -- Close */
    $('.left-icon').on('click', function () {
        closeModal()
    })

    /** Mobile Filters -- Modal -- Reset */
    $('.close-text').on('click', function () {
        if (modalType == 'tag') {
            $(".xs-tags input[type='checkbox']").prop("checked", false);
            getInputCheckbox({ reset: true })
        } else if (modalType == 'ingrendents') {
            $('.ingredients-input').val('')
        } else {
            servingSize = 0
            $('.size-box').removeClass('size-box-active')
        }
    })
    
    // app serving size
    $('.size-box').on('click', function () {
        var active = $(this).hasClass('size-box-active')
        if (active) {
            $(this).removeClass('size-box-active')
            servingSize = 0
        } else {
            $('.size-box-active').removeClass('size-box-active')
            $(this).addClass('size-box-active')
            servingSize = $(this).text()
        }
    })
    
    // pc ingredients click
    $('.form_item_input>.icon-fangdajing').on('click',function () {
        getRecipeData()
    })

    // pc ingredients input
    $('.form_item_input>input[name="ingredients"]').on('input',function () {
       // showClearIcon('.icon-fangdajing','.ing_icon',this.value.length>0)
    })

    // pc clear 
    $('.form_item_input>.icon-qingkong').on('click',function () {
        var classList = $(this).attr('class')
        if(classList.indexOf('ing_icon')>-1){
            $('.form_item_input>input[name="ingredients"]').val('')
            showClearIcon('.icon-fangdajing','.ing_icon',false)
        }
        if(classList.indexOf('size_icon')>-1){
            $('.form_item_input>select[name="servingSize"]').val('')
            showClearIcon('.icon-xiangxiajiantou','.size_icon',false)
            servingSize = ''
        }
        getRecipeData()
    })

    // pc serving size
    $('.form_item_input>select[name="servingSize"]').on('change',function () {
        servingSize = this.value
        showClearIcon('.icon-xiangxiajiantou','.size_icon',Boolean(this.value.trim()))
        getRecipeData()
    })
}

function openModal() {
    $('.full-mask').css({ 'display': 'block' })
    $('.custom-modal').css({ 'display': 'block' })
    $('body,html').css({ 'height': '100%', 'overflow': 'hidden' });
    $('.custom-modal').addClass('showMove')
}
function closeModal() {
    $('.full-mask').css({ 'display': 'none' })
    $('.custom-modal').css({ 'display': 'none' })
    $('body,html').removeAttr("style");
    $('.custom-modal').removeClass('showMove')
}
function showClearIcon(activeIcon,icon,bool){
    if(bool){
        $(icon).css({display:'flex'})
        $(activeIcon).css({display:'none'})
    }else{
        $(icon).css({display:'none'})
        $(activeIcon).css({display:'flex'})
    }
}

window.onresize = function(){
    var docWidth =  document.documentElement.clientWidth;
    if(docWidth>=768){
        document.querySelector('.tag-action').style.display = 'none'
        document.querySelector('.filter_form').style.display = 'flex'
    }else{
        document.querySelector('.tag-action').style.display = 'flex'
        document.querySelector('.filter_form').style.display = 'none'
    }

    $('.nput[name="ingredients"]').val('')
    servingSize = ''
},

// document.addEventListener('scroll',winScroll,false);
// function winScroll(e){
//     var fixedDom = document.getElementsByClassName('to-top-icon')[0];
//     console.log(e,fixedDom.offsetTop,document.body.scrollTop)
//     if(fixedDom.offsetTop < document.body.scrollTop){

//         // fixedDom.classList.remove("fixed"); 
//         fixedDom.setAttribute('style', 'display:none');
//     };
//     if(fixedDom.offsetTop > document.body.scrollTop){
//         fixedDom.setAttribute('style', 'display:block');
//     };
// }

/**  Check smart device is mobile ?  */
function isMobile() {
    return screen.width < 768
}

/**  Back to the tOP  */
function topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    // document.getElementsByClassName('to-top-icon').style.display = 'none'
}

/**  Filter recipe data based on the selected tag  **/
function getInputCheckbox({ reset = false, filter = false }) {
    if (reset) filtersArray = []
    // if (tagName&&tagName.length>0){
    //     for(var s=0;s<tagName.length;s++){
    //         var index = filtersArray.indexOf(tagName[s])
    //         if(checked&&index === -1) filtersArray.push(tagName[s])
    //         if(!checked&&index > -1) filtersArray.splice(index, 1)
    //     }
    // } 
    newRecipeData = []
    if (recipeList.length > 0 && filtersArray.length > 0) {
        for (var d = 0; d < recipeList.length; d++) {
            var tags = recipeList[d].tags
            if (tags) {
                var tagArr = null
                if (tags.indexOf(' / ') > -1) {
                    tagArr = tags.split(' / ')
                } else {
                    tagArr = tags.split(',')
                }

                var intersection = tagArr.filter(function (v) {
                    return filtersArray.indexOf(v) > -1
                })
                if (intersection.length > 0) {
                    newRecipeData.push(recipeList[d])
                }
            }
        }
        total = newRecipeData.length
        // filters data page
        initRecipeListHtml(newRecipeData.slice(0, pageSize))

    } else {
        total = recipeList.length
        initRecipeListHtml(displayRecipeData)
    }
    page = 1
    recipeListPagetion()
}

/**  Open TAB details data  **/
function openChildrenTag(that) {
    var node = $(that).children('.open_icon')
    if (node.length == 0) {
        $(that).children('.right_icon').addClass('open_icon')
        $(that).siblings('.children_tag').css({
            'display': 'block'
        })
    } else {
        $(that).children('.right_icon').removeClass('open_icon')
        $(that).siblings('.children_tag').css({
            'display': 'none'
        })
    }
}

/** Date format conversion **/
function dateFormat(times) {
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    var dates = new Date(times)
    var month = dates.getMonth()
    var year = dates.getFullYear()
    var day = dates.getDate()
    day = day < 10 ? '0' + day : day
    return months[month] + ' ' + day + ', ' + year
}

/** Get the label data and compose the layout  */
function initRecipeTagsHtml() {
    $.ajax({
        url: baseUrl + "/shopify/recipe/tags/list",
        type: "GET",
        dataType: "JSON",
        success: function (data) {
            if (data.code == 200) {
                var tags = data.result

                generateTagHtmlCode({tagArr:tags,platform:'lg',el:'.lg-tags'})
                generateTagHtmlCode({tagArr:tags,platform:'xs',el:'.xs-tags'})

                $('.xs-tags input[type="checkbox"]').on('click', function () {
                    var tagName = $(this).attr('data-value')
                    var checked = $(this).prop('checked')
                    checked ? filtersArray.push(tagName) : filtersArray.splice(filtersArray.indexOf(tagName), 1)
                     multipleCheckboxCode({that:$(this),checked:checked,tagName:tagName,platform:'xs'})
                })

                $('.lg-tags input[type="checkbox"]').on('click', function () {

                    var tagName = $(this).attr('data-value')
                    var checked = $(this).prop('checked')

                    multipleCheckboxCode({that:$(this),checked:checked,tagName:tagName,platform:'lg'})
                  
                })

            }
        }
    })
}

function generateTagHtmlCode({tagArr, platform,el}){
    if(!(tagArr instanceof Array) || tagArr.length == 0) return ''
    var htmlStr = ''
    for(var i = 0;i<tagArr.length;i++){
        htmlStr += `
                    <div class="tags_border_row">
                        <div class="tags_row" onclick="openChildrenTag(this)">
                            <div class="tags_title">` + tagArr[i].tag + `</div>
                            <div class="right_icon"></div>
                        </div>
                        <div class="children_tag">`
        var subTags = tagArr[i].children
        if(subTags !== null && subTags.length>0){
            for (var k = 0; k < subTags.length; k++) {
                var tagName = subTags[k].tag.toLowerCase().replace(/\ /g, "-")
                var inputIndex = platform +'-' + tagName + '-'+k
                htmlStr += `<div class="children_sub_tag">
                                <div class="second">
                                    <input type="checkbox" id="` + inputIndex + `" data-value="` + subTags[k].tag + `">
                                    <label for="` + inputIndex + `">
                                        <span class="checkbox_label">` + subTags[k].tag + `</span>
                                    </label>
                                </div>` 
                    var secondChildTag = subTags[k].children
                    if(secondChildTag&&secondChildTag.length>0){
                    htmlStr += `<ul>`
                                secondChildTag.forEach(function(element,keys){
                                    var tagName = element.tag.toLowerCase().replace(/\ /g, "-")
                                    var inputId = platform +'-' + tagName + '-'+ keys
                        htmlStr += `<li>
                                        <input type="checkbox" id="${inputId}" data-value="${element.tag}">
                                        <label for="${inputId}">
                                            <span class="checkbox_label">${element.tag}</span>
                                        </label>
                                    </li>`
                                });
                    htmlStr += ` </ul>`
                    }
                htmlStr += `</div>`
            }
        }    
            htmlStr += `</div>` 
        htmlStr += `</div>` 
    }

     $(el).html(htmlStr)
}


/**
*  that: this
*   checked: checkbox status
*/
function multipleCheckboxCode({that,checked,tagName,platform}){

  var checkedTags = []
// handle tag children
    var parent = that.parent().parent('ul').prev() //second
    if(parent.length>0&&parent.hasClass('second')){
        var ulNodes =  that.parent().parent().children('li')
        if(ulNodes.length>0){
            var checkeds = []
        //    checkedTags.push(tagName)
            for(var i=0;i<ulNodes.length;i++){
                var childChecked = ulNodes.eq(i).children('input').prop('checked')
                var childValue = ulNodes.eq(i).children('input').attr('data-value')
                if(childChecked===checked){
                   checkedTags.push(ulNodes.eq(i).children('input').attr('data-value'))  
                }
                checkeds.push(childChecked)
            }
        
            // checkbox unchecked checked or indeterminate
            var parentLabelTag = parent.children('input').attr('data-value')
            if(checkeds.includes(true)&&checkeds.includes(false)){
                parent.children('label').addClass('indeterminate')
            }else if(checkeds.includes(true)&&!checkeds.includes(false)){
                parent.children('label').removeClass('indeterminate')
                // checkedTags.push(parentLabelTag)
            }else{
                parent.children('input[type="checkbox"]').prop('checked',false)
            }
           
            if(checkeds.includes(true)){
                parent.children('input[type="checkbox"]').prop('checked',true)
            }else{
                parent.children('label').removeClass('indeterminate')
            }
            // if(!checked){
            //      if(filtersArray.includes(parentLabelTag))filtersArray.splice(filtersArray.indexOf(parentLabelTag),1)
            // }
        }
    }else{
        var nextLabel = that.next()
        if(nextLabel.hasClass('indeterminate')){
            nextLabel.removeClass('indeterminate')
        }
    
        // handle tag parent
        if(that.parent().next().length>0){
            var liNodes = that.parent().next().children('li')
            if(liNodes.length>0){
                for(var i=0;i<liNodes.length;i++){
                    (function(index){
                        liNodes.eq(index).children('input').prop('checked',checked)
                        checkedTags.push(liNodes.eq(index).children('input').attr('data-value'))
                    })(i)
                }
            }
        }else{
             checkedTags.push(tagName)
        }
    } 
     
     if (checkedTags&&checkedTags.length>0){
        for(var s=0;s<checkedTags.length;s++){
            var index = filtersArray.indexOf(checkedTags[s])
            if(checked&&index === -1) filtersArray.push(checkedTags[s])
            if(!checked&&index > -1) filtersArray.splice(index, 1)
        }
    } 

    if(platform=='lg')getInputCheckbox({})
}


/** Requesting recipe data **/
function getRecipeData() {
    var ingredientsStr = $('input[name="ingredients"]').val().trim()
    var servingSizeNum = servingSize == '8+' ? 8 : servingSize
    $.ajax({
        url: baseUrl + "/shopify/recipe/list",
        type: "GET",
        dataType: "JSON",
        data: {
            ingredients: ingredientsStr,
            servings: servingSizeNum || ''
        },
        success: function (data) {
            if (data.code == 200) {
                recipeList = data.result
                total = data.result.length
                totalPage = Math.ceil(total / pageSize)
                displayRecipeData = recipeList.slice(0, pageSize)
                initRecipeListHtml(displayRecipeData)
                // recipeListPagetion()
            }
        }
    })
}

/** Composition recipe data typesetting  **/
function initRecipeListHtml(displayRecipeData) {
    if (page == 1) {
        $('#recipe-list').html('')
    }
    if (displayRecipeData.length == 0) {
        $('.recipe-empty').css({ 'display': 'flex' })
        $('.pagination').css({ 'display': 'none' })
    } else {
        $('.recipe-empty').css({ 'display': 'none' })
        var recipeStr = '';
        for (var t = 0; t < displayRecipeData.length; t++) {
            var dates = displayRecipeData[t].createTime
            // var dateStr = dateFormat(dates)

            var recipeTitle = displayRecipeData[t].title
            recipeTitle = recipeTitle.toLowerCase().replace(/\ /g, '-')
            var url = 'https://' + document.domain + blogUrl + recipeTitle
            recipeStr += `
                        <div class="o-layout__item u-1/1 `+ grid_item_width + `">
                            <div class="blog js-sr-loaded" style="visibility: visible;">
                                <div class="blog__media-wrapper">
                                    <a href="` + url + `" class="home-blog__link blog-link">
                                        <div class="blog__media"> 
                                            <div class="o-ratio o-ratio--custom" style="padding-bottom: 55%;">
                                            <div class="o-ratio__content">
                                                <img src="` + displayRecipeData[t].picture + `" 
                                                data-src="`+ displayRecipeData[t].picture + `"
                                                class="home-blog__media-img blog__img lazyload"
                                                width="360"
                                                height="200"
                                                loading="lazy"
                                            />
                                            </div>
                                        </div>
                                    </div>
                                    </a>
                                </div>
                                <a href="`+ url + `" class="recipe_name">` + displayRecipeData[t].name + `</a>
                            </div>
                        </div> `
        }
    }

    $('#recipe-list').append(recipeStr)
    if (totalPage == page) {
        $('.load_btn').css({ display: 'none' })
    } else {
        $('.load_btn').css({ display: 'block' })
    }

    //
    // <div class="blog__details">
    //     <h2 class="blog__title h4">` + displayRecipeData[t].title + `</h2>
    //     <div class="blog__author">
    //         <p class="blog__author__text">` + displayRecipeData[t].authorTeam + `</p>
    //     </div>

    //     <div class="blog__date label label--brand"> 
    //         <p class="blog__date-text label__text">` + dateStr + ` </p>
    //     </div>
    // </div>

}

/** Recipe data is paginated  */
function recipeListPagetion() {
    if (total <= pageSize) {
        $('#recipe-pagination').css({ 'display': 'none' })
    } else {
        $('#recipe-pagination').css({ 'display': 'block' })
        var totalPage = Math.ceil(total / pageSize)
        var pageStr = ''
        pageStr +=
            `<span class="prev" onclick="changePage('prev')"><i class="icon icon--left-t"></i><span class="icon-fallback__text">PreviousPage</span></span>`
        for (var p = 1; p <= totalPage; p++) {
            pageStr += `<span class="page" onclick="changePage(` + p + `)">` + p + `</span> `
        }
        pageStr +=
            `<span class="prev" onclick="changePage('next')"><i class="icon icon--right-t"></i><span class="icon-fallback__text">Next Page</span></span>`

        $('#pages').html(pageStr)
        changePage()
    }
}

/** Recipe data paging operation  */
function changePage(val) {
    var totalPage = Math.ceil(total / pageSize)

    if (val == 'prev') page--
    if (val == 'next') page++
    if (typeof val == 'number') {
        if (val == page) return
        if (val < 1 || val > totalPage) {
            $('.load_btn').css({ display: 'none' })
            return
        }
        page = val
    }

    if (val) {
        var start = (pageSize * (page - 1))
        var end = (pageSize * page)
        var displayRecipeData = []

        if (filtersArray.length > 0) displayRecipeData = newRecipeData.slice(start, end)
        else displayRecipeData = recipeList.slice(start, end)
        initRecipeListHtml(displayRecipeData)
    }

    return
    var prevStyle = page == 1 ? 'hidden' : 'visible'
    $('#pages').children('.prev').eq(0).css({
        visibility: prevStyle
    })

    $('#pages').children('.current').removeClass('current')
    $('#pages').children('.page').eq(page - 1).addClass('current')

    var nextStyle = page == totalPage ? 'hidden' : 'visible'
    $('#pages').children('.prev').eq(1).css({
        visibility: nextStyle
    })
}
